import { useEffect, useState } from 'react';
// import { mockIssuesData } from '../data/mockData';
import type { IssuesResponse, IssuesData, Message } from '../types';
import { formatIssues, getAUBaseUrl, getAuthHeader } from '../utils';

const useIssuesApi = (
  clientId: string,
  messages?: Message[],
): { issues?: IssuesData; loading: boolean; error?: Error } => {
  const [issues, setIssues] = useState<IssuesData>({
    unresolvedIssues: [],
    resolvedIssues: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();

  useEffect(() => {
    setLoading(!!messages?.length);
  }, [messages]);

  useEffect((): void => {
    if (!loading || !clientId || !messages?.length) return;
    fetch(`${getAUBaseUrl()}/api/get-message-summary?businessId=${clientId}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify({ messages }),
    })
      .then(response => {
        if (!response?.ok) throw new Error();
        return response.json();
      })
      .then((response: IssuesResponse) => formatIssues(response))
      .then((data: IssuesData) => setIssues(data))
      .catch((error: Error) => {
        /* eslint-disable no-console */
        console.log('Failed to fetch issues data:', error.message);
        // setIssues(mockIssuesData);
        setError(error);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return { issues, loading, error };
};

export default useIssuesApi;
